var path = 'msi/datepicker/datepicker.html';
var html = "<div uib-daypicker tabindex=\"0\" template-url=\"msi/datepicker/day.html\" class=\"og-uib-daypicker\"></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;